import createReducer from '../../utils/createReducer';
import {
  GET_METAL_STREAM_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_PRODUCTS_ERROR,
  GET_METAL_STREAM_GOLD_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_GOLD_PRODUCTS_ERROR,
  GET_METAL_STREAM_SILVER_PRODUCTS_SUCCESS,
  GET_METAL_STREAM_SILVER_PRODUCTS_ERROR,
  CREATE_METAL_STREAM_PRODUCTS_SUCCESS,
  CREATE_METAL_STREAM_PRODUCTS_ERROR,
  UPDATE_METAL_STREAM_PRODUCTS_SUCCESS,
  UPDATE_METAL_STREAM_PRODUCTS_ERROR,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS,
  UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR,
} from '../../actions/metalStream/metalStreamActionConstants';

const initialState = {
  Products: [],
  GoldProducts: [],
  SilverProducts: [],
  Settings: {
    Amount: '',
    GoldPercentage: 50,
    SilverPercentage: 50,
    SelectedGoldProduct: '',
    SelectedSilverProduct: '',
  },
  Funding: {},
  error: '',
};

export default createReducer(
  {
    [GET_METAL_STREAM_PRODUCTS_SUCCESS]: getProducts,
    [GET_METAL_STREAM_PRODUCTS_ERROR]: getProductsError,
    [GET_METAL_STREAM_GOLD_PRODUCTS_SUCCESS]: getGoldProducts,
    [GET_METAL_STREAM_GOLD_PRODUCTS_ERROR]: getGoldProductsError,
    [GET_METAL_STREAM_SILVER_PRODUCTS_SUCCESS]: getSilverProducts,
    [GET_METAL_STREAM_SILVER_PRODUCTS_ERROR]: getSilverProductsError,
    [CREATE_METAL_STREAM_PRODUCTS_SUCCESS]: createSelectedProducts,
    [CREATE_METAL_STREAM_PRODUCTS_ERROR]: createSelectedProductsError,
    [UPDATE_METAL_STREAM_PRODUCTS_SUCCESS]: updateSelectedProducts,
    [UPDATE_METAL_STREAM_PRODUCTS_ERROR]: updateSelectedProductsError,
    [CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS]: createMetalStreamBankApplicationFunding,
    [CREATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR]: createMetalStreamBankApplicationFundingError,
    [UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_SUCCESS]: updateMetalStreamBankApplicationFunding,
    [UPDATE_METAL_STREAM_BANK_APPLICATION_FUNDING_ERROR]: updateMetalStreamBankApplicationFundingError,
  },
  initialState,
);

function getProducts(state, { payload }) {
  return {
    ...state,
    Products: payload,
    error: '',
  };
}

function getProductsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function getGoldProducts(state, { payload }) {
  return {
    ...state,
    GoldProducts: payload,
    error: '',
  };
}

function getGoldProductsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function getSilverProducts(state, { payload }) {
  return {
    ...state,
    SilverProducts: payload,
    error: '',
  };
}

function getSilverProductsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function createSelectedProducts(state, { payload }) {
  return {
    ...state,
    Settings: { ...payload },
    error: '',
  };
}

function createSelectedProductsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function updateSelectedProducts(state, { payload }) {
  return {
    ...state,
    Settings: { ...payload },
    error: '',
  };
}

function updateSelectedProductsError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function createMetalStreamBankApplicationFunding(state, { payload }) {
  return {
    ...state,
    Funding: { ...payload },
    error: '',
  };
}

function createMetalStreamBankApplicationFundingError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}

function updateMetalStreamBankApplicationFunding(state, { payload }) {
  return {
    ...state,
    Funding: { ...payload },
    error: '',
  };
}

function updateMetalStreamBankApplicationFundingError(state, { payload }) {
  return {
    ...state,
    error: payload,
  };
}
